/*
 * Copyright (c) 2016 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.visflux.chord

import com.macrofocus.common.properties.EnumProperties
import com.macrofocus.common.properties.MutableProperties
import com.macrofocus.common.properties.MutableProperty

abstract class AbstractChordModel<Node, Link, Column> : ChordModel<Node, Link, Column> {
    protected val properties: MutableProperties<ChordModel.PropertyType> = EnumProperties(ChordModel.PropertyType.entries.toTypedArray())
    private val listeners: MutableList<ChordListener> = ArrayList()

    init {
        properties.createProperty(ChordModel.PropertyType.MinimizedCrossing, false)
    }

    @Suppress("UNCHECKED_CAST")
    override val minimizedCrossing: MutableProperty<Boolean>
        get() = properties.getProperty(ChordModel.PropertyType.MinimizedCrossing) as MutableProperty<Boolean>

    /** Shares a property of the model with the settings of a document. */
    fun <T> bind(type: ChordModel.PropertyType, property: MutableProperty<T>) {
        properties.replaceProperty(type, property)
    }

    override fun addChordListener(listener: ChordListener) {
        listeners.add(listener)
    }

    override fun removeChordListener(listener: ChordListener) {
        listeners.remove(listener)
    }

    protected fun notifyChordChanged() {
        for (listener in listeners.toList()) {
            listener.chordChanged()
        }
    }
}
